import { render, staticRenderFns } from "./ParticipantTeamContainer.vue?vue&type=template&id=5d821de2&"
import script from "./ParticipantTeamContainer.vue?vue&type=script&lang=js&"
export * from "./ParticipantTeamContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports